export const ROLE_ORDER = [2, 3, 1];

export const ROLE_META = {
  2: {
    short: "U",
    label: "Utilisateur",
    description:
      "Modules visibles par les adhérents et utilisateurs classiques.",
    tone: "sky",
    chip: "bg-sky-100 text-sky-800 ring-sky-200 dark:bg-sky-500/10 dark:text-sky-300 dark:ring-sky-500/20",
  },
  3: {
    short: "E",
    label: "Enseignant",
    description: "Modules dédiés aux enseignants, coachs et encadrants.",
    tone: "amber",
    chip: "bg-amber-100 text-amber-800 ring-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-500/20",
  },
  1: {
    short: "A",
    label: "Administrateur",
    description: "Modules de gestion avancée réservés aux administrateurs.",
    tone: "fuchsia",
    chip: "bg-fuchsia-100 text-fuchsia-800 ring-fuchsia-200 dark:bg-fuchsia-500/10 dark:text-fuchsia-300 dark:ring-fuchsia-500/20",
  },
};

export const ROLE_DEFS = {
  2: [
    { label: "Absences", key: "display_absences" },
    { label: "Calendrier", key: "display_calendrier" },
    { label: "Chat", key: "display_chat" },
    { label: "Boutique", key: "display_boutique" },
    { label: "Commandes & Règlements", key: "display_commandes" },
    { label: "Prépa Physique", key: "display_prepa_physique" },
    { label: "Actualités", key: "display_news" },
    { label: "Galerie Photos", key: "display_galerie" },
    { label: "Lexique", key: "display_lexique" },
    { label: "Arbitrage Judo", key: "display_arbitrage" },
    { label: "Applications Judo", key: "display_applications" },
    { label: "Techniques Judo", key: "display_techniques" },
    { label: "Techniques Quizz", key: "display_techniquesquizz" },
    { label: "Vote Sondage Utilisateur", key: "display_vote" },
  ],
  3: [
    { label: "Appel Présence", key: "display_appels" },
    { label: "Tableau Appel", key: "display_tableauappel" },
    { label: "Passage Ceinture", key: "display_passage" },
    { label: "Grade CN", key: "display_gradecn" },
    { label: "Événements", key: "display_evenements" },
    {
      label: "Prépa Physique Coaching",
      key: "display_prepa_physique_coaching",
    },
    { label: "Suivi Compétitions", key: "display_suivicompetition" },
    { label: "Palmarès", key: "display_palmares" },
    { label: "Objectifs Adhérents", key: "display_objectifs" },
    { label: "ToDoList", key: "display_todolist" },
    { label: "Techniques Enseignants", key: "display_techniquesenseignants" },
    { label: "Catégories", key: "display_categories" },
  ],
  1: [
    { label: "Articles Admin", key: "display_articlesadmin" },
    { label: "Dépenses Recettes", key: "display_depensesrecettes" },
    { label: "Coachings", key: "display_coaching" },
    { label: "Heures Enseignement", key: "display_heures_enseignants" },
    { label: "Inventaire", key: "display_inventaire" },
    { label: "Prêt Matériel", key: "display_pretmateriel" },
    { label: "Chat Page Admin", key: "display_chat_admin" },
    { label: "Message Admin", key: "display_messages_admin" },
    { label: "Vote Sondage Admin", key: "display_voteadmin" },
    { label: "Pages Personnalisées", key: "display_pagespersonnalisees" },
  ],
};

export const DESCRIPTIONS = {
  display_absences: "Les adhérents peuvent signaler leurs absences.",
  display_calendrier: "Affichage du calendrier des événements et inscriptions.",
  display_chat: "Module de discussion entre les adhérents du même groupe.",
  display_boutique: "Affichage de la boutique en ligne pour les adhérents.",
  display_commandes: "Affichage des commandes et règlements des adhérents.",
  display_prepa_physique: "Module de préparation physique pour les adhérents.",
  display_news: "Affichage des actualités et annonces pour les adhérents.",
  display_galerie: "Galerie photos des événements et activités.",
  display_lexique: "Lexique des termes et techniques de judo.",
  display_arbitrage: "Module d'arbitrage pour les adhérents.",
  display_applications: "Applications liées au judo pour les adhérents.",
  display_techniques: "Techniques de judo pour les adhérents.",
  display_techniquesquizz:
    "Quiz sur les techniques de judo pour les adhérents.",
  display_vote: "Module de vote pour les adhérents.",

  display_appels: "Gestion des appels de présence des adhérents.",
  display_tableauappel: "Tableau de suivi des appels de présence.",
  display_passage: "Gestion des passages de ceinture.",
  display_gradecn: "Gestion des grades CN.",
  display_evenements: "Gestion des événements.",
  display_prepa_physique_coaching:
    "Module de préparation physique pour les enseignants.",
  display_suivicompetition: "Suivi des compétitions pour les enseignants.",
  display_palmares: "Palmarès des adhérents.",
  display_objectifs: "Gestion des objectifs des adhérents.",
  display_todolist: "ToDoList des enseignants et administrateurs.",
  display_techniquesenseignants: "Gestion des techniques par les enseignants.",
  display_categories:
    "Catégories d'âges, de poids et répartition des adhérents.",

  display_articlesadmin:
    "Gestion des articles de la boutique, licences, cotisations et réductions.",
  display_depensesrecettes: "Gestion des dépenses et recettes.",
  display_coaching: "Gestion des heures de coachings.",
  display_heures_enseignants: "Gestion des heures de cours des enseignants.",
  display_inventaire: "Gestion de l'inventaire.",
  display_pretmateriel: "Gestion des prêts de matériel.",
  display_chat_admin: "Module de surveillance des discussions dans le chat.",
  display_messages_admin: "Module de surveillance des messages.",
  display_voteadmin: "Gestion des votes et sondages.",
  display_pagespersonnalisees: "Gestion des pages personnalisées.",
};

export const EXPECTED_KEYS = ROLE_ORDER.flatMap((roleId) =>
  ROLE_DEFS[roleId].map((module) => module.key),
);

export function getDefaultFilters() {
  return {
    query: "",
    roleId: "all",
    status: "all",
  };
}

export function coerceBool(value, fallback = false) {
  if (value === undefined || value === null) return fallback;

  if (typeof value === "boolean") return value;

  if (typeof value === "number") return value !== 0;

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();

    if (["true", "1", "yes", "on"].includes(normalized)) return true;
    if (["false", "0", "no", "off"].includes(normalized)) return false;
  }

  return !!value;
}

export function normalizeText(value = "") {
  return String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function calculateModulesStats(roleDefs, settings) {
  let total = 0;
  let enabled = 0;
  let disabled = 0;

  const byRole = {};

  ROLE_ORDER.forEach((roleId) => {
    const modules = roleDefs?.[roleId] || [];

    let roleTotal = 0;
    let roleEnabled = 0;

    modules.forEach((module) => {
      roleTotal += 1;
      total += 1;

      if (coerceBool(settings?.[module.key], false)) {
        roleEnabled += 1;
        enabled += 1;
      } else {
        disabled += 1;
      }
    });

    byRole[roleId] = {
      total: roleTotal,
      enabled: roleEnabled,
      disabled: Math.max(roleTotal - roleEnabled, 0),
      percent: roleTotal ? Math.round((roleEnabled / roleTotal) * 100) : 0,
    };
  });

  return {
    total,
    enabled,
    disabled,
    percent: total ? Math.round((enabled / total) * 100) : 0,
    byRole,
  };
}

export function filterRoleDefs(roleDefs, filters, settings = {}) {
  const query = normalizeText(filters?.query || "");
  const roleFilter = String(filters?.roleId || "all");
  const status = filters?.status || "all";

  const result = {};

  ROLE_ORDER.forEach((roleId) => {
    if (roleFilter !== "all" && String(roleId) !== roleFilter) {
      result[roleId] = [];
      return;
    }

    result[roleId] = (roleDefs?.[roleId] || []).filter((module) => {
      if (query) {
        const searchable = normalizeText(
          `${module.label || ""} ${module.key || ""} ${
            DESCRIPTIONS[module.key] || ""
          }`,
        );

        if (!searchable.includes(query)) return false;
      }

      if (status === "enabled") {
        return coerceBool(settings?.[module.key], false);
      }

      if (status === "disabled") {
        return !coerceBool(settings?.[module.key], false);
      }

      return true;
    });
  });

  return result;
}

export function buildModulesPayload(settings) {
  const payload = EXPECTED_KEYS.reduce((acc, key) => {
    acc[key] = coerceBool(settings?.[key], false);
    return acc;
  }, {});

  if (settings?.id != null) {
    payload.id = settings.id;
  }

  return payload;
}
